import PropTypes from 'prop-types';
import React from 'react';
import { Interpolate } from 'react-i18next';
import EmptyStates from '../empty-states';
import withTranslate from '../../hoc/with-translate';
import styles from './no-user-posts.scss';

const NoUserPosts = ({ t, ...props }) =>
  <EmptyStates
    className={styles.container}
    title={t('no-user-posts.nothing-here-yet')}
    content={<Interpolate i18nKey="no-user-posts.check-back-soon" useDangerouslySetInnerHTML={true}/>}
    {...props}
  />;

NoUserPosts.propTypes = {
  t: PropTypes.func,
};

export default withTranslate(NoUserPosts);



// WEBPACK FOOTER //
// ./app/components/no-user-posts/no-user-posts.js